<template>
  <div class="m-2 md:m-0 md:mt-8">
    <app-user></app-user>
  </div>
</template>

<script>
import AppUser from '../components/AppUser.vue'
export default {
  components: {AppUser}
}
</script>

<style>

</style>